<template>
  <div>
    <v-toolbar height="80" dark color="#212121" flat>
      <v-btn icon @click="backToHomepage" aria-label="Zurück zur wellcomefit.ch Startseite">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <img class="mr-2" style="object-fit: contain" width="50px" height="50px" src="/img/roody_logo.png" />

      <v-toolbar-title class="text-subtitle-1" style="font-weight: 1000; text-transform: uppercase; font-size: 1.4rem !important">
        Online Abo
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon disabled style="visibility: hidden">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card max-width="1200" class="px-5 mt-5 mx-auto" flat>
      <v-row v-if="studioList">
        <v-btn
          v-if="$route && $route.query && $route.query.previousRoute"
          fab
          dark
          class="mt-2"
          color="white"
          @click="$router.push($route.query.previousRoute)">
          <v-icon color="black">mdi-chevron-left</v-icon>
        </v-btn>

        <v-col v-if="selectedStudio">
          <v-row>
            <v-col cols="12">
              <v-card-title class="d-flex justify-center">{{ selectedStudio.name }}</v-card-title>
            </v-col>
            <v-col cols="12" v-if="showPreSaleMessage">
              <v-alert type="info" v-if="selectedStudio.code !== 'arbon'">
                Jetzt ein Abo lösen und bis zur Eröffnung
                {{ selectedStudio.code === "stgallenost" ? "am Montag, 08. April 2024" : "im Frühjahr 2024" }}
                an allen Standorten der well come FIT Gruppe kostenlos trainieren.

                {{
                  selectedStudio.code === "stgallenost"
                    ? `Profitiere zusätzlich von einem Preisvorteil in Höhe von CHF 99.-, wenn du dein Abo jetzt
                            löst.`
                    : ""
                }}
              </v-alert>
            </v-col>
            <v-dialog persistent v-model="showPreSaleCityDialog" width="500">
              <v-card>
                <v-card-title class="text-h5 primary text-white mb-5">
                  {{ selectedStudio.code === "arbon" ? "Baustellenvorverkauf" : "Vorverkauf" }}
                </v-card-title>
                <v-card-text>
                  {{
                    selectedStudio.code === "arbon"
                      ? "Teste hier, ob Du von unserem Vorverkaufsangebot profitieren kannst: Gib die Postleitzahl deines Wohnortes ein und sichere dir die geschenkte Aktivierungsgebühr im Wert von CHF 99. - "
                      : "Teste hier, ob Du in den Genuss des Vorverkaufs-Angebot kommst und gebe die Postleizahl deines Wohnortes ein: "
                  }}
                </v-card-text>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field label="Postleitzahl" type="number" class="mx-auto d-flex textfield" v-model="cityNumber"></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-btn color="primary" text @click="selectedStudio = null" v-if="!directLink"> Zurück </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="checkCityDialog">Bestätigen</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-col v-if="!loadingContracts" cols="12">
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-left">Verträge</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr @click="pushToContract(contract._id)" v-for="contract in contractList" :key="contract._id">
                    <td>{{ contract.internalTitle }}</td>

                    <td class="d-flex justify-end align-center">
                      <v-btn icon><v-icon>mdi-pen-plus</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col v-else cols="12">
              <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-col>
            <v-col v-if="!directLink" cols="12" class="justify-center d-flex">
              <v-btn @click="selectedStudio = null" text>Zurück</v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-else>
          <v-row no-gutters justify="center" class="mb-0 mt-3" v-if="isBlackFridayPeriod">
            <v-col cols="12" md="10" lg="8">
              <v-alert color="#111" dark class="text-center rounded-lg elevation-4 border-neon" style="border: 1px solid #00e676">
                <div class="text-center mb-2">
                  <v-chip color="#00e676" label x-small class="black--text font-weight-bold mb-2">LIMITED TIME</v-chip>
                  <h2 class="text-h5 font-weight-black white--text" style="text-shadow: 0 0 10px rgba(0, 230, 118, 0.4)">BLACK FRIDAY DEALS</h2>
                </div>
                <p class="text-body-2 mb-0 grey--text text--lighten-1">
                  Wähle dein Studio und sichere dir bis zu <strong>CHF 1'000.- Rabatt</strong>.
                </p>
              </v-alert>
            </v-col>
          </v-row>

          <v-row justify="center" class="mb-0">
            <v-col cols="12" sm="8" md="6">
              <v-text-field
                class="custom-search-field"
                v-model="search"
                rounded
                filled
                autocomplete="off"
                append-icon="mdi-magnify"
                placeholder="Suche nach Kanton, Stadt oder PLZ"
                solo
                hide-details
                clearable></v-text-field>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-space-evenly justify-center">
            <v-col cols="12" class="text-center">
              <v-chip
                :color="selectedCanton === canton ? 'primary' : 'default'"
                @click="selectedCanton = selectedCanton === canton ? null : canton"
                v-for="canton of studioCantons"
                :key="canton"
                class="ma-2"
                small>
                {{ canton }}
              </v-chip>
            </v-col>

            <v-col v-for="studio of filteredStudios" :key="studio._id" cols="12" sm="6" lg="4" class="d-flex">
              <v-card class="d-flex flex-column fill-height card-glass" style="width: 100%">
                <div class="pa-5 d-flex flex-column flex-grow-1 mx-auto">
                  <v-card-subtitle class="pa-0 font-weight-black" style="font-size: 0.8rem; text-align: center" v-if="studio.adresse">
                    <v-icon start small>mdi-map-marker-outline</v-icon>
                    {{ studio.adresse }}
                  </v-card-subtitle>

                  <v-spacer></v-spacer>

                  <v-card-title
                    class="card-title text-h5 font-weight-black pa-0 mt-4 mx-auto"
                    style="line-height: 1.3; font-weight: 1000 !important; text-transform: uppercase !important">
                    {{ studio.name }}
                  </v-card-title>

                  <div class="mt-4">
                    <v-btn height="40px" color="primary" class="font-weight-black" @click="selectedStudio = studio" block large>
                      mitglied werden
                      <v-icon end>{{ isBlackFridayPeriod ? "mdi-fire" : "mdi-arrow-right" }}</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col v-if="loading" cols="12" class="text-center pa-10">
              <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
              <p class="text-h6 mt-4 grey--text">Lade Studios...</p>
            </v-col>
            <v-col cols="12" v-if="!loading && filteredStudios.length === 0" class="text-center pa-10">
              <v-icon size="60" color="grey">mdi-magnify-remove-outline</v-icon>
              <p class="text-h6 mt-4 grey--text">Keine Studios für deine Suche gefunden.</p>
              <p class="grey--text">Setze evtl. den Kantons-Filter zurück.</p>
              <v-btn v-if="selectedCanton" @click="selectedCanton = null" color="primary" text>Filter zurücksetzen</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog persistent v-model="showAktionstagePopup" max-width="550px" style="z-index: 999999998">
        <v-card class="popup-card" elevation="16">
          <v-img src="https://app.wellcomefit.ch/img/einmalig/flyer-bg.png" height="220px" cover class="hero-image-popup">
            <v-btn icon small text @click="showAktionstagePopup = false" class="close-btn" aria-label="Popup schliessen">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-img>
          <div class="pa-6 text-center">
            <h2 class="text-h4 font-weight-black mb-2" :style="{ color: colors.primary }">🎉 Willkommen zur Aktion!</h2>
            <p class="text-h6 font-weight-bold mb-1" :style="{ color: colors.textPrimary }">Tag der offenen Tür</p>
            <p class="text-h6 mb-6 font-weight-light" :style="{ color: colors.textSecondary }">SA. 1. & SO. 2. NOVEMBER 2025</p>
            <v-list color="transparent" dense class="mb-6 text-left">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :color="colors.primary">mdi-gift-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> <strong>CHF 99.- Anmeldegebühr</strong> geschenkt </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :color="colors.primary">mdi-calendar-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Bis zu <strong>2 Monate gratis</strong> Training </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :color="colors.primary">mdi-trophy-variant-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Grosser <strong>Wettbewerb</strong> & tolle Preise </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-btn
              :color="colors.primary"
              :style="{ color: colors.textOnPrimary }"
              @click="showAktionstagePopup = false"
              x-large
              block
              class="font-weight-bold rounded-lg"
              elevation="4">
              <v-icon left>mdi-arrow-right-bold-circle-outline</v-icon>
              Standort auswählen<br />
              und starten!
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="showBlackFridayPopup" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="650px" style="z-index: 999999999">
        <v-card dark>
          <div class="black-friday-header">
            <v-btn icon small text @click="showBlackFridayPopup = false" class="close-btn" aria-label="Popup schliessen">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
            <v-card-title class="bf-title font-weight-black text-center">
              <v-icon size="48" left :color="colors.primary">mdi-fire</v-icon>
              BLACK FRIDAY
              <v-icon size="48" right :color="colors.primary">mdi-fire</v-icon>
            </v-card-title>
            <div class="bf-subtitle text-center font-weight-bold">Unsere heissesten Deals des Jahres! Gültig: 19. Nov – 7. Dez 2025</div>
          </div>

          <v-card-text class="pa-0">
            <v-tabs v-model="blackFridayTab" background-color="transparent" :color="colors.primary" grow>
              <v-tab>well come FIT</v-tab>
              <v-tab>winti FIT</v-tab>
            </v-tabs>

            <v-tabs-items v-model="blackFridayTab" class="pa-6" style="background-color: #333">
              <v-tab-item>
                <p class="text-center white--text">Gültig für alle Studios (ausser Pfungen & Winterthur)</p>
                <v-list color="transparent" dark dense>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>1 Jahr: CHF 690.-</strong> <span class="text-decoration-line-through">statt 789.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 20% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>2 Jahre: CHF 1'199.-</strong> <span class="text-decoration-line-through">statt 1'479.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 30% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>3 Jahre: CHF 1'599.-</strong> <span class="text-decoration-line-through">statt 2'169.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 40% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>4 Jahre: CHF 1'999.-</strong> <span class="text-decoration-line-through">statt 2'859.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 50% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>

              <v-tab-item>
                <p class="text-center white--text">Exklusiv für Studios Pfungen & Winterthur</p>
                <v-list color="transparent" dark dense>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>1 Jahr: CHF 890.-</strong> <span class="text-decoration-line-through">statt 980.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 20% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>2 Jahre: CHF 1'579.-</strong> <span class="text-decoration-line-through">statt 1'960.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 30% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>3 Jahre: CHF 2'199.-</strong> <span class="text-decoration-line-through">statt 2'940.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 40% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon :color="colors.primary">mdi-brightness-percent</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        ><strong>4 Jahre: CHF 2'749.-</strong> <span class="text-decoration-line-through">statt 3'920.-</span></v-list-item-title
                      >
                      <v-list-item-subtitle>+ 50% auf Zusatzpakete </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <div class="pa-6 pt-0" style="background-color: #333">
            <v-divider class="mb-4"></v-divider>
            <v-list color="transparent" dark dense class="conditions-list">
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-check-circle-outline</v-icon></v-list-item-icon>
                <v-list-item-content>Wir übernehmen deine Restlaufzeit (bis 6 Monate) </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-check-circle-outline</v-icon></v-list-item-icon>
                <v-list-item-content>Zusatzpaketupgrades für bestehende Mitglieder: 20% Rabatt </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-alert-circle-outline</v-icon></v-list-item-icon>
                <v-list-item-content>Nicht kumulierbar mit anderen Rabatten </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-btn
              :color="colors.primary"
              :style="{ color: colors.textOnPrimary }"
              @click="showBlackFridayPopup = false"
              x-large
              block
              class="font-weight-bold rounded-lg mt-4"
              elevation="4">
              <v-icon left>mdi-arrow-right-bold-circle-outline</v-icon>
              jetzt profitieren
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex"
import api from "@/api"

export default {
  name: "contractCreatorExtern",
  data() {
    return {
      loading: true, // Starte im Ladezustand
      // POPUP PROPERTIES
      showAktionstagePopup: false,
      colors: {
        primary: "#00963f", // Dein Grün
        accent: "#00A551",
        textPrimary: "#1A1A1A",
        textSecondary: "#555555",
        textOnPrimary: "#FFFFFF",
      },

      // NEU: Black Friday Popup
      showBlackFridayPopup: false,
      blackFridayTab: 0, // 0 = WCF, 1 = Winti

      // NEU: Für die Suchleiste
      search: "",

      // Vorhandene data properties
      directLink: false,
      skipPresale: false,
      showPreSaleMessage: false,
      showPreSaleCityDialog: false,
      studioList: [],

      loadingContracts: false,
      selectedStudio: null,
      contractList: [],
      cityNumber: null,
      allowedCities: [],
      selectedCanton: null,
    }
  },
  created() {
    this.fetchStudios()
    console.log(this.$route)

    // Aktionstage Check
    if (this.isAktionstageActive) {
      setTimeout(() => {
        this.showAktionstagePopup = true
      }, 500)
    }

    // NEU: Black Friday Check
    // Priorisiert BF über Aktionstage, falls beide (fälschlicherweise) aktiv wären
    if (this.isBlackFridayPeriod) {
      this.showAktionstagePopup = false // BF ist wichtiger
      setTimeout(() => {
        //  this.showBlackFridayPopup = true
      }, 500)
    }
  },
  mounted() {
    if (this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["toggleNavigationBarVisibility", "setNavigationBarText", "setNavigationbarVisibility"]),
    backToHomepage() {
      let queryHasBf = this.$route.query.hasOwnProperty("blackfriday") || this.$route.query.hasOwnProperty("Blackfriday")
      let preview = queryHasBf ? "?show" : ""
      window.open("https://wellcomefit.ch/blackfriday" + preview, "_self")
    },
    obfeldenCheck(e) {
      if (this.$moment().isAfter(this.$moment("01-05-2024", "DD-MM-YYYY"))) return true
      return !e.name.toLowerCase().includes("obfelden")
    },
    checkCityDialog() {
      if (this.allowedCities.includes(this.cityNumber.toString())) {
        this.$toast.success("Deine Postleitzahl ist gültig. Du kannst dich jetzt registrieren.")
        this.showPreSaleCityDialog = false
      } else {
        this.$toast.error(
          "Die eingegebene Postleitzahl ist leider nicht gültig für den Vorverkauf. Falls du dennoch teilnehmen möchtest, kontaktiere uns bitte unter info@wellcomefit.ch, um weitere Informationen zu erhalten."
        )
        if (this.selectedStudio.code === "arbon") {
          this.skipPresale = true
          this.showPreSaleCityDialog = false
        }
      }
    },
    async fetchStudios() {
      // this.loading = true; // Ist jetzt schon true von data()
      try {
        let studios = await api.fetchPublicStudios()
        console.log(studios)

        if (this.$route.query.studio) {
          let studio = studios.find((e) => e.code === this.$route.query.studio)
          if (studio) {
            this.directLink = true
            this.selectedStudio = studio
            this.checkPreSaleStudios()
          }
        }
        this.studioList = studios
      } catch (error) {
        console.error("Fehler beim Laden der Studios:", error)
        // Hier könntest du z.B. ein Toast-Fehler zeigen
      } finally {
        // HIER DIE ÄNDERUNG:
        // Dieser Block wird *immer* ausgeführt, egal ob try oder catch.
        this.loading = false
      }
    },
    checkPreSaleStudios() {
      // Aktuelles Datum
      return false
      const today = this.$moment()
      const targetDate = this.$moment("2024-03-01")
      if (today.isSameOrAfter(targetDate, "day")) {
        this.showPreSaleCityDialog = this.selectedStudio.code === "arbon"
        this.showPreSaleMessage = this.selectedStudio.code === "arbon"
        if (this.selectedStudio.code === "arbon") {
          this.allowedCities = [
            "9320",
            "9322",
            "8599",
            "8590",
            "9314",
            "9315",
            "9325",
            "9306",
            "9305",
            "9323",
            "9326",
            "9327",
            "9403",
            "9404",
            "9422",
            "9423",
            "9425",
            "9424",
            "9036",
            "9404",
            "9308",
            "9313",
          ]
        }
      }
    },
    pushToContract(id) {
      // HINWEIS: Du hast bereits einen 'bfHackPublic'.
      // Der ist anscheinend für 'blackFriday' im Query-Parameter.
      // Mein neues Popup ist datumsgesteuert. Das passt so,
      // aber du könntest den Query-Parameter 'blackFriday' hier
      // ebenfalls setzen, wenn 'isBlackFridayPeriod' true ist.
      // Aktuell lasse ich deine Logik hier unverändert.

      if (this.bfHackPublic) {
        this.$router.push("/contract/create/" + id + "/" + this.selectedStudio._id + "/" + this.skipPresale + "?blackFriday")
      } else if (this.isAktionstageActive) {
        this.$router.push("/contract/create/" + id + "/" + this.selectedStudio._id + "/" + this.skipPresale + "?aktionstage")
      } else {
        this.$router.push("/contract/create/" + id + "/" + this.selectedStudio._id + "/" + this.skipPresale)
      }
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationItems", "navigationVisible"]),

    // NEU: Black Friday Datums-Check
    isBlackFridayPeriod() {
      // Ausgelöst vom 14. Nov bis 1. Dez (deine Anforderung)
      // Das Angebot selbst ist 19. - 7. dez (steht im Popup)
      // !!! WICHTIG: FÜR TESTZWECKE KANNST DU DAS DATUM HIER ÄNDERN ODER EINFACH `return true` SCHREIBEN !!!
      return (
        this.$moment().isBetween("2025-11-19", "2025-12-07", "day", "[]") ||
        this.$route?.query?.hasOwnProperty("Blackfriday") ||
        this.$route?.query?.hasOwnProperty("blackfriday")
      ) // '[]' inkludiert Start/Ende
    },

    // Kombinierte Computed Property für die Studio-Filterung
    filteredStudios() {
      let studios = this.studioList.filter((e) => this.obfeldenCheck(e))
      if (this.selectedCanton) {
        studios = studios.filter((e) => e.canton === this.selectedCanton)
      }
      if (this.search) {
        const searchLower = this.search.toLowerCase()
        studios = studios.filter((studio) => {
          const address = studio.adresse || ""
          const name = studio.name || ""
          const canton = studio.canton || ""
          const code = studio.code || ""
          const zip = studio.zip ? studio.zip.toString() : ""
          return (
            name.toLowerCase().includes(searchLower) ||
            address.toLowerCase().includes(searchLower) ||
            canton.toLowerCase().includes(searchLower) ||
            code.toLowerCase().includes(searchLower) ||
            zip.includes(searchLower)
          )
        })
      }
      return studios
    },

    isAktionstageActive() {
      return (
        (this.$route && this.$route.query && this.$route.query.hasOwnProperty("aktionstage") && this.$moment().isBefore("2025-11-03")) ||
        this.$moment().isBefore("2025-11-03")
      )
    },
    bfHackPublic() {
      return location && location.href && location.href.includes("blackFriday") && this.$moment().isBetween("2024-11-21", "2024-12-07")
    },
    studioCantons() {
      if (!this.studioList.length > 0) return []
      return [...new Set(this.studioList.filter((e) => e.canton).map((e) => e.canton))]
    },
  },
  watch: {
    async selectedStudio() {
      if (this.selectedStudio !== null) {
        this.checkPreSaleStudios()
        this.loadingContracts = true
        let contracts = await api.fetchContractsPublic(this.selectedStudio._id)
        this.contractList = contracts
        if (contracts.length === 1 && !this.showPreSaleMessage) {
          this.pushToContract(contracts[0]._id)
        }
        console.log(this.contractList, this.showPreSaleMessage)
        this.loadingContracts = false
      } else {
        this.contractList = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* VORHANDENER STYLE */
.textfield {
  width: 150px;
}

/* POPUP STYLES (Aktionstage) */
$color-primary: #00963f;
$color-accent: #00a551;
$color-dark: #1a1a1a;
$color-text-primary: #1a1a1a;
$color-text-secondary: #555555;
$color-text-on-primary: #ffffff;
$color-light-grey: #f5f5ff;

.popup-card {
  overflow: hidden;
}
.hero-image-popup {
  position: relative;
}
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  backdrop-filter: blur(4px);
  z-index: 10;
}
.v-list-item__icon {
  margin-inline-end: 20px !important;
}
.v-list-item__title {
  font-size: 1.05rem;
  line-height: 1.5;
}

/* ==============================================
  MODERNES LAYOUT (Studioauswahl)
==============================================
*/

/* Stil für die Suchleiste (Vuetify 2 'solo' Stil) */
.custom-search-field.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

/* "Glassmorphism"-Karten */
.card-glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px !important;
  color: #2c3e50;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1) !important;
}
.card-glass:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 32px 0 rgba($color-primary, 0.2), 0 0 20px rgba($color-primary, 0.1) !important;
}
.card-glass .v-card__subtitle {
  color: #34495e;
  font-size: 0.9rem;
}
.card-title {
  word-break: break-word;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  hyphens: none;
}

/* ==============================================
  "HOT DEAL" Tag Styling (ENTFERNT)
==============================================
*/
/*
.bf-deal-tag {
  ...
}
*/

/* ==============================================
  STYLES FÜR DAS BLACK FRIDAY POPUP
==============================================
*/
.black-friday-header {
  position: relative;
  padding: 24px 0;
  background: linear-gradient(135deg, #222 25%, #111 100%);
  overflow: hidden;
}

.bf-title {
  position: relative;
  z-index: 2;
  color: white;
  font-size: 3rem;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);
  line-height: 1.2;
}

.bf-subtitle {
  position: relative;
  z-index: 2;
  color: #f1f1f1;
  font-size: 1rem;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

/* Anpassung für V2 Listen in dunklem Popup */
.conditions-list .v-list-item__icon {
  margin-inline-end: 12px !important;
  align-self: flex-start;
  margin-top: 6px;
}
.conditions-list .v-list-item__content {
  font-size: 0.9rem;
  line-height: 1.4;
}

/* ==============================================
  BLACK FRIDAY - POPUP MOBIL-FIXES (BLEIBEN ERHALTEN)
==============================================
*/

@media (max-width: 960px) {
  /* $vuetify.breakpoint.smAndDown */
  .bf-title {
    font-size: 2.5rem; // Etwas kleiner
    flex-direction: column; // Icons und Text stapeln
    line-height: 1.3;
  }
  .bf-title .v-icon {
    margin: 0 0 8px 0 !important; // Icons zentriert darüber
    padding: 0 !important;
  }
  .bf-subtitle {
    font-size: 0.9rem;
    padding: 0 12px;
  }
}
</style>
